define('presentation/shell/bindings/contactSupportMenuBinding',[], function () {
    return {
        init: function (element, valueAccessor) {
            const { hideMenu } = ko.unwrap(valueAccessor());

            //#region Outside Click Check
            const _checkIfOutsideMenuClicked = (/** @type { MouseEvent }*/ event) => {
                /** @type { EventTarget }*/
                let clickedElement = event.target;
                do {
                    if (clickedElement === element) {
                        return;
                    }
                    // Go up the DOM
                    clickedElement = clickedElement.parentNode;
                } while (clickedElement);

                hideMenu();
            };
            //#endregion

            document.addEventListener('click', _checkIfOutsideMenuClicked);

            ko.utils.domNodeDisposal.addDisposeCallback(element, () => {
                document.removeEventListener('click', _checkIfOutsideMenuClicked);
            });
        }
    };
});
